/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_SessionInputs */

const en_page_title_session = /** @type {(inputs: Page_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session`)
};

const nl_page_title_session = /** @type {(inputs: Page_Title_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessie`)
};

/**
* | output |
* | --- |
* | "Session" |
*
* @param {Page_Title_SessionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_session = /** @type {((inputs?: Page_Title_SessionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_SessionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_session(inputs)
	return en_page_title_session(inputs)
});